/**
 * Build a path
 * @returns A builder object with an add method and a toString method
 * @example
 * ```ts
 * const path = PathBuilder().add("users").add("123").toString();
 * const url = `https://example.com${path}`;
 * ```
 */
export function PathBuilder() {
    let path = "";
    const builder = {
        add: (pathToAdd) => {
            if (Array.isArray(pathToAdd)) {
                pathToAdd.forEach((p) => {
                    if (p) {
                        path += `/${p}`;
                    }
                });
            }
            else if (pathToAdd) {
                path += `/${pathToAdd}`;
            }
            return builder;
        },
        toString: () => path,
    };
    return builder;
}
